import React from 'react'

function TermsOfServices(): React.JSX.Element {

  return (
    <div className="dashboard">
      <h2>Terms of Services</h2>
      <p>
        This is terms of services page.
      </p>
    </div>
  )
}

export default TermsOfServices
